import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react'; // eslint-disable-next-line @typescript-eslint/no-empty-interface

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MarkerPinIcon = function MarkerPinIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    width: "33",
    height: "33",
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M18.2671 12.1791C19.3809 13.2929 19.3809 15.0986 18.2671 16.2124C17.1533 17.3262 15.3475 17.3262 14.2338 16.2124C13.12 15.0986 13.12 13.2929 14.2338 12.1791C15.3475 11.0653 17.1533 11.0653 18.2671 12.1791Z",
      stroke: "#1C1327",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M25.5846 13.8324C25.5846 16.3671 24.4593 18.7711 22.5113 20.3937L19.4513 22.9444C18.2313 23.9617 17.3193 25.2977 16.8166 26.8044L16.2513 28.4991L15.686 26.8044C15.1833 25.2977 14.2713 23.9604 13.0513 22.9444L9.98997 20.3937C8.0433 18.7711 6.91797 16.3671 6.91797 13.8324V13.8804C6.91797 8.0564 11.7406 4.67773 16.2513 4.67773C20.762 4.67773 25.5846 8.0564 25.5846 13.8804",
      stroke: "#1C1327",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }));
};
export default MarkerPinIcon;